import { render, staticRenderFns } from "./utox-result.vue?vue&type=template&id=cedb2d22&scoped=true&lang=pug&"
import script from "./utox-result.vue?vue&type=script&lang=ts&"
export * from "./utox-result.vue?vue&type=script&lang=ts&"
import style0 from "./utox-result.vue?vue&type=style&index=0&id=cedb2d22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedb2d22",
  null
  
)

export default component.exports